// src/enums.ts
var UserRole = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  OPS_MANAGER: "OPS_MANAGER",
  AGENT: "AGENT",
  VERIFICATION_STAFF: "VERIFICATION_STAFF",
  CLIENT: "CLIENT"
};
var LoanLifecycleStage = {
  APPLICATION: "APPLICATION",
  KYC_REVIEW: "KYC_REVIEW",
  APPROVED: "APPROVED",
  DISBURSED: "DISBURSED",
  REPAYMENT: "REPAYMENT",
  PRE_DUE: "PRE_DUE",
  OVERDUE: "OVERDUE",
  WRITE_OFF: "WRITE_OFF",
  CLOSED: "CLOSED"
};
var OverdueCategory = {
  S1: "S1",
  CATEGORY_A: "CATEGORY_A",
  CATEGORY_B: "CATEGORY_B",
  CATEGORY_C: "CATEGORY_C",
  CATEGORY_Z: "CATEGORY_Z"
};
var LoanType = {
  STANDARD: "STANDARD",
  MICRO: "MICRO"
};
var MicroLoanTier = {
  T1: "T1",
  T2: "T2",
  T3: "T3",
  T4: "T4",
  T5: "T5"
};
var TierChangeDirection = {
  INITIAL: "INITIAL",
  PROMOTION: "PROMOTION",
  DEMOTION: "DEMOTION",
  MANUAL_OVERRIDE: "MANUAL_OVERRIDE",
  FREEZE: "FREEZE",
  UNFREEZE: "UNFREEZE"
};
var TierChangeReason = {
  INITIAL: "INITIAL",
  PROMOTION: "PROMOTION",
  OVERDUE_DEMOTION: "OVERDUE_DEMOTION",
  MANUAL_OVERRIDE: "MANUAL_OVERRIDE",
  WRITE_OFF_FREEZE: "WRITE_OFF_FREEZE",
  ADMIN_FREEZE: "ADMIN_FREEZE",
  ADMIN_UNFREEZE: "ADMIN_UNFREEZE",
  CORRECTING_SYSTEM_ERROR: "CORRECTING_SYSTEM_ERROR",
  ADMIN_REMEDIATION: "ADMIN_REMEDIATION",
  PROMOTIONAL: "PROMOTIONAL",
  OTHER: "OTHER"
};
var MicroLoanFreezeReason = {
  WRITE_OFF: "WRITE_OFF",
  MANUAL_FREEZE: "MANUAL_FREEZE"
};
var PipelineStatus = {
  NEW: "NEW",
  OLD: "OLD",
  BROKEN_PROMISE: "BROKEN_PROMISE",
  PROMISE_TO_PAY: "PROMISE_TO_PAY",
  DONE: "DONE"
};
var KycStatus = {
  PENDING: "PENDING",
  ACTION_REQUIRED: "ACTION_REQUIRED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var KycDocumentType = {
  NATIONAL_ID_FRONT: "NATIONAL_ID_FRONT",
  NATIONAL_ID_BACK: "NATIONAL_ID_BACK",
  SELFIE: "SELFIE",
  PROOF_OF_INCOME: "PROOF_OF_INCOME",
  PROOF_OF_ADDRESS: "PROOF_OF_ADDRESS"
};
var BorrowerApplicationStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  REJECTED: "REJECTED",
  CONVERTED: "CONVERTED",
  WITHDRAWN: "WITHDRAWN"
};
var TicketStatus = {
  OPEN: "OPEN",
  IN_PROGRESS: "IN_PROGRESS",
  AWAITING_INFO: "AWAITING_INFO",
  RESOLVED: "RESOLVED",
  CLOSED: "CLOSED"
};
var TicketPriority = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  URGENT: "URGENT"
};
var InteractionType = {
  PHONE_CALL: "PHONE_CALL",
  SMS: "SMS",
  WHATSAPP: "WHATSAPP",
  IN_PERSON: "IN_PERSON",
  EMAIL: "EMAIL",
  OTHER: "OTHER",
  SYSTEM_NOTE: "SYSTEM_NOTE"
};
var InteractionOutcome = {
  REACHED: "REACHED",
  NOT_REACHED: "NOT_REACHED",
  WRONG_NUMBER: "WRONG_NUMBER",
  PROMISE_TO_PAY: "PROMISE_TO_PAY",
  REFUSED_TO_PAY: "REFUSED_TO_PAY",
  DISPUTED: "DISPUTED",
  ESCALATED: "ESCALATED",
  CALLBACK_REQUESTED: "CALLBACK_REQUESTED",
  PARTIAL_PAYMENT: "PARTIAL_PAYMENT",
  FULL_PAYMENT: "FULL_PAYMENT",
  BROKEN_PROMISE: "BROKEN_PROMISE"
};
var DisbursementStatus = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  HELD: "HELD",
  APPROVED: "APPROVED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  REJECTED: "REJECTED"
};
var PenaltyCompoundingMethod = {
  SIMPLE: "SIMPLE",
  COMPOUND: "COMPOUND"
};
var TicketType = {
  CLIENT_DISPUTE: "CLIENT_DISPUTE",
  PAYMENT_ISSUE: "PAYMENT_ISSUE",
  ACCOUNT_ISSUE: "ACCOUNT_ISSUE",
  TECHNICAL_ISSUE: "TECHNICAL_ISSUE",
  ESCALATION: "ESCALATION",
  OTHER: "OTHER"
};
var UserAccountStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  LOCKED: "LOCKED",
  DEACTIVATED: "DEACTIVATED"
};
var ClientFacingOverdueLabel = {
  ON_TRACK: "ON_TRACK",
  PAYMENT_DUE_SOON: "PAYMENT_DUE_SOON",
  OVERDUE: "OVERDUE",
  SERIOUSLY_OVERDUE: "SERIOUSLY_OVERDUE"
};
var PortalPaymentStatus = {
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
};
var PortalPaymentMethod = {
  ECOCASH: "ECOCASH",
  INNBUCKS: "INNBUCKS",
  BANK_TRANSFER: "BANK_TRANSFER",
  CASH_AT_AGENT: "CASH_AT_AGENT",
  OTHER: "OTHER"
};
var AuditSeverity = {
  NORMAL: "NORMAL",
  ELEVATED: "ELEVATED",
  HIGH_RISK: "HIGH_RISK"
};
var TriggerKey = {
  CRON_CATEGORY_MIGRATION: "CRON_CATEGORY_MIGRATION",
  CRON_PENALTY_CALCULATION: "CRON_PENALTY_CALCULATION",
  CRON_PTP_TO_BP_CONVERSION: "CRON_PTP_TO_BP_CONVERSION",
  CRON_UNPROCESSED_TIME_ALERT: "CRON_UNPROCESSED_TIME_ALERT",
  CRON_TARGET_SHORTFALL_WARNING: "CRON_TARGET_SHORTFALL_WARNING",
  CRON_PRE_DUE_REMINDER: "CRON_PRE_DUE_REMINDER",
  CRON_PTP_DAY_REMINDER: "CRON_PTP_DAY_REMINDER",
  CRON_PAYMENT_RECONCILIATION: "CRON_PAYMENT_RECONCILIATION",
  CRON_SCHEDULED_REPORT_GENERATION: "CRON_SCHEDULED_REPORT_GENERATION",
  CRON_MICRO_TIER_SWEEP: "CRON_MICRO_TIER_SWEEP",
  CRON_MICRO_FREEZE_SYNC: "CRON_MICRO_FREEZE_SYNC",
  CRON_TICKET_SLA_MONITOR: "CRON_TICKET_SLA_MONITOR",
  CRON_BACKUP: "CRON_BACKUP",
  EVENT_LOAN_DISBURSED: "EVENT_LOAN_DISBURSED",
  EVENT_PAYMENT_RECEIVED: "EVENT_PAYMENT_RECEIVED",
  EVENT_LOAN_CLOSED: "EVENT_LOAN_CLOSED",
  EVENT_MICRO_TIER_EVALUATION: "EVENT_MICRO_TIER_EVALUATION",
  EVENT_KYC_COMPLETED: "EVENT_KYC_COMPLETED",
  EVENT_CLIENT_ASSIGNED: "EVENT_CLIENT_ASSIGNED",
  EVENT_CATEGORY_Z_ENTRY: "EVENT_CATEGORY_Z_ENTRY",
  EVENT_TICKET_CREATED: "EVENT_TICKET_CREATED",
  EVENT_TICKET_RESPONSE: "EVENT_TICKET_RESPONSE",
  EVENT_CONFIG_CHANGED: "EVENT_CONFIG_CHANGED",
  EVENT_DISBURSEMENT_FAILED: "EVENT_DISBURSEMENT_FAILED",
  EVENT_PAYMENT_PUSH_TIMEOUT: "EVENT_PAYMENT_PUSH_TIMEOUT",
  EVENT_USER_LOGIN: "EVENT_USER_LOGIN",
  EVENT_OTP_LOCKOUT: "EVENT_OTP_LOCKOUT"
};
var ThresholdKey = {
  THRESHOLD_PENALTY_CAP_REACHED: "THRESHOLD_PENALTY_CAP_REACHED",
  THRESHOLD_AGENT_FOLLOW_UP_DUE: "THRESHOLD_AGENT_FOLLOW_UP_DUE",
  THRESHOLD_SLA_BREACH_IMMINENT: "THRESHOLD_SLA_BREACH_IMMINENT",
  THRESHOLD_OVERDUE_MIGRATION_SPIKE: "THRESHOLD_OVERDUE_MIGRATION_SPIKE",
  THRESHOLD_SMS_GATEWAY_DEGRADED: "THRESHOLD_SMS_GATEWAY_DEGRADED"
};
var NotificationKey = {
  NOTIFY_LOAN_DISBURSEMENT: "NOTIFY_LOAN_DISBURSEMENT",
  NOTIFY_PAYMENT_RECEIVED: "NOTIFY_PAYMENT_RECEIVED",
  NOTIFY_PRE_DUE_REMINDER: "NOTIFY_PRE_DUE_REMINDER",
  NOTIFY_OVERDUE_NOTICE: "NOTIFY_OVERDUE_NOTICE",
  NOTIFY_CATEGORY_ESCALATION: "NOTIFY_CATEGORY_ESCALATION",
  NOTIFY_PTP_REMINDER: "NOTIFY_PTP_REMINDER",
  NOTIFY_LOAN_CLOSURE: "NOTIFY_LOAN_CLOSURE",
  NOTIFY_MANUAL_PAYMENT_VERIFIED: "NOTIFY_MANUAL_PAYMENT_VERIFIED",
  NOTIFY_MANUAL_PAYMENT_REJECTED: "NOTIFY_MANUAL_PAYMENT_REJECTED",
  NOTIFY_KYC_STATUS_UPDATE: "NOTIFY_KYC_STATUS_UPDATE",
  NOTIFY_TICKET_RESPONSE: "NOTIFY_TICKET_RESPONSE",
  NOTIFY_MICRO_TIER_PROMOTION: "NOTIFY_MICRO_TIER_PROMOTION",
  NOTIFY_MICRO_TIER_DEMOTION: "NOTIFY_MICRO_TIER_DEMOTION",
  NOTIFY_MICRO_LOAN_REJECTION: "NOTIFY_MICRO_LOAN_REJECTION",
  NOTIFY_NEW_CLIENT_ASSIGNMENT: "NOTIFY_NEW_CLIENT_ASSIGNMENT",
  NOTIFY_PTP_EXPIRY: "NOTIFY_PTP_EXPIRY",
  NOTIFY_UNPROCESSED_TIME_ALERT: "NOTIFY_UNPROCESSED_TIME_ALERT",
  NOTIFY_TARGET_SHORTFALL_WARNING: "NOTIFY_TARGET_SHORTFALL_WARNING",
  NOTIFY_CATEGORY_Z_ENTRY: "NOTIFY_CATEGORY_Z_ENTRY",
  NOTIFY_KYC_COMPLETION: "NOTIFY_KYC_COMPLETION",
  NOTIFY_TICKET_ESCALATION: "NOTIFY_TICKET_ESCALATION"
};
var AlertKey = {
  ALERT_BACKUP_FAILURE: "ALERT_BACKUP_FAILURE",
  ALERT_CRITICAL_SERVICE_DOWN: "ALERT_CRITICAL_SERVICE_DOWN",
  ALERT_MIGRATION_SPIKE: "ALERT_MIGRATION_SPIKE",
  ALERT_DISBURSEMENT_EXHAUSTED: "ALERT_DISBURSEMENT_EXHAUSTED"
};
var TriggerExecutionModel = {
  CRON: "CRON",
  QUEUE: "QUEUE",
  SYNC: "SYNC"
};
var TriggerExecutionStatus = {
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  PARTIAL_FAILURE: "PARTIAL_FAILURE",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED"
};
var TriggerFailureDispositionStatus = {
  OPEN: "OPEN",
  RETRIED: "RETRIED",
  DISCARDED: "DISCARDED"
};
var SystemAlertStatus = {
  OPEN: "OPEN",
  ACKNOWLEDGED: "ACKNOWLEDGED",
  RESOLVED: "RESOLVED"
};
var ID_PREFIX = {
  CLIENT: "CLT",
  CLIENT_FLAG: "FLG",
  BORROWER_APPLICATION: "BAP",
  LOAN: "LN",
  MICRO_LOAN: "ML",
  REPAYMENT: "RPY",
  DISBURSEMENT: "DSB",
  AGENT: "AGT",
  USER: "USR",
  TARGET: "TRG",
  REPORT_RUN: "RPT",
  REPORT_SCHEDULE: "SCH",
  TICKET: "TKT",
  INTERACTION: "INT",
  AUDIT: "AUD",
  PAYMENT_ATTEMPT: "PAY",
  MANUAL_PAYMENT_CONFIRMATION: "MPC",
  PORTAL_NOTIFICATION: "NTF",
  STATEMENT_IMPORT: "IMP"
};

// src/responses.ts
function successResponse(data, meta, status = 200) {
  const body = { status: "success", data };
  if (meta) body.meta = meta;
  return new Response(JSON.stringify(body), {
    status,
    headers: { "Content-Type": "application/json" }
  });
}
function errorResponse(httpStatus, code, message, details) {
  const body = {
    status: "error",
    error: { code, message }
  };
  if (details) body.error.details = details;
  return new Response(JSON.stringify(body), {
    status: httpStatus,
    headers: { "Content-Type": "application/json" }
  });
}
function notFound(message = "Resource not found.") {
  return errorResponse(404, "RESOURCE_NOT_FOUND", message);
}
function forbidden(message = "You do not have permission.") {
  return errorResponse(403, "FORBIDDEN", message);
}
function unauthenticated(message = "Authentication required.") {
  return errorResponse(401, "UNAUTHENTICATED", message);
}
function validationError(details) {
  return errorResponse(400, "VALIDATION_ERROR", "Request validation failed.", details);
}
function businessRuleViolation(message) {
  return errorResponse(422, "BUSINESS_RULE_VIOLATION", message);
}
function conflict(message) {
  return errorResponse(409, "CONFLICT", message);
}
function rateLimited(retryAfter) {
  const res = errorResponse(429, "RATE_LIMITED", "Too many requests.");
  res.headers.set("Retry-After", String(retryAfter));
  return res;
}
function internalError(requestId) {
  return errorResponse(
    500,
    "INTERNAL_ERROR",
    `An unexpected error occurred. Reference: ${requestId}`
  );
}

// src/pagination.ts
var ALLOWED_SORT_ORDERS = /* @__PURE__ */ new Set(["asc", "desc"]);
var MAX_PER_PAGE = 100;
function parsePagination(url, defaultSortBy = "created_at") {
  const page = Math.max(1, Number.parseInt(url.searchParams.get("page") ?? "1", 10));
  const per_page = Math.min(
    MAX_PER_PAGE,
    Math.max(1, Number.parseInt(url.searchParams.get("per_page") ?? "20", 10))
  );
  const rawOrder = url.searchParams.get("sort_order") ?? "desc";
  const sort_order = ALLOWED_SORT_ORDERS.has(rawOrder) ? rawOrder : "desc";
  const sort_by = url.searchParams.get("sort_by") ?? defaultSortBy;
  return {
    page,
    per_page,
    sort_by,
    sort_order,
    offset: (page - 1) * per_page
  };
}
function buildMeta(total_items, page, per_page) {
  return {
    page,
    per_page,
    total_items,
    total_pages: Math.ceil(total_items / per_page)
  };
}

// src/crypto.ts
async function hmacHash(data, key) {
  const encoder = new TextEncoder();
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    encoder.encode(key),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const signature = await crypto.subtle.sign("HMAC", cryptoKey, encoder.encode(data));
  return arrayBufferToHex(signature);
}
function arrayBufferToHex(buffer) {
  return [...new Uint8Array(buffer)].map((b) => b.toString(16).padStart(2, "0")).join("");
}
function generateOtp(length = 6) {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return String(array[0]).slice(0, length).padStart(length, "0");
}

// src/dates.ts
function nowISO() {
  return (/* @__PURE__ */ new Date()).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function addDays(isoDate, days) {
  const d = new Date(isoDate);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().replace(/\.\d{3}Z$/, "Z");
}
function daysBetween(dateA, dateB) {
  const a = new Date(dateA).getTime();
  const b = new Date(dateB).getTime();
  return Math.floor(Math.abs(b - a) / (1e3 * 60 * 60 * 24));
}

// src/ids.ts
function generateUUID() {
  return crypto.randomUUID();
}
function formatPublicId(prefix, sequence) {
  return `${prefix}-${String(sequence).padStart(5, "0")}`;
}

// src/validation.ts
var PHONE_REGEX = /^\+[1-9]\d{7,14}$/;
var CLIENT_NAME_MAX_LEN = 200;
var NATIONAL_ID_MAX_LEN = 50;
var NOTES_MAX_LEN = 2e3;
var LOAN_AMOUNT_MIN = 100;
var LOAN_AMOUNT_MAX = 1e8;
var MICRO_LOAN_AMOUNT_MIN = 500;
var MAX_KYC_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024;
var REQUIRED_KYC_DOCUMENT_TYPES = [
  KycDocumentType.NATIONAL_ID_FRONT,
  KycDocumentType.NATIONAL_ID_BACK,
  KycDocumentType.SELFIE,
  KycDocumentType.PROOF_OF_INCOME
];
var OPTIONAL_KYC_DOCUMENT_TYPES = [KycDocumentType.PROOF_OF_ADDRESS];
function isValidPhone(phone) {
  return PHONE_REGEX.test(phone);
}
function isValidE164(phone) {
  return PHONE_REGEX.test(phone);
}

// src/permissions.ts
var PERMISSIONS = {
  SUPER_ADMIN: {
    can_view_category_z: true,
    can_manage_users: true,
    can_manage_disbursements: true,
    can_review_kyc: true,
    can_edit_clients: true,
    can_assign_clients: true,
    can_flag_clients: true,
    can_raise_client_tickets: true,
    can_record_repayments: true,
    can_contact_clients: false,
    can_log_interactions: false,
    can_view_reports: true,
    can_generate_reports: true,
    can_manage_targets: true,
    can_manage_report_schedules: true,
    can_view_audit_all: true,
    can_view_audit_own: true,
    can_manage_system_config: true,
    managed_roles: [
      UserRole.ADMIN,
      UserRole.OPS_MANAGER,
      UserRole.AGENT,
      UserRole.VERIFICATION_STAFF
    ]
  },
  ADMIN: {
    can_view_category_z: false,
    can_manage_users: true,
    can_manage_disbursements: false,
    can_review_kyc: false,
    can_edit_clients: false,
    can_assign_clients: true,
    can_flag_clients: true,
    can_raise_client_tickets: true,
    can_record_repayments: true,
    can_contact_clients: false,
    can_log_interactions: false,
    can_view_reports: true,
    can_generate_reports: true,
    can_manage_targets: true,
    can_manage_report_schedules: true,
    can_view_audit_all: false,
    can_view_audit_own: false,
    can_manage_system_config: false,
    managed_roles: [UserRole.AGENT, UserRole.VERIFICATION_STAFF]
  },
  OPS_MANAGER: {
    can_view_category_z: false,
    can_manage_users: false,
    can_manage_disbursements: false,
    can_review_kyc: false,
    can_edit_clients: false,
    can_assign_clients: false,
    can_flag_clients: false,
    can_raise_client_tickets: false,
    can_record_repayments: true,
    can_contact_clients: false,
    can_log_interactions: false,
    can_view_reports: true,
    can_generate_reports: true,
    can_manage_targets: false,
    can_manage_report_schedules: false,
    can_view_audit_all: false,
    can_view_audit_own: false,
    can_manage_system_config: false,
    managed_roles: []
  },
  AGENT: {
    can_view_category_z: false,
    can_manage_users: false,
    can_manage_disbursements: false,
    can_review_kyc: false,
    can_edit_clients: false,
    can_assign_clients: false,
    can_flag_clients: false,
    can_raise_client_tickets: false,
    can_record_repayments: false,
    can_contact_clients: true,
    can_log_interactions: true,
    can_view_reports: false,
    can_generate_reports: false,
    can_manage_targets: false,
    can_manage_report_schedules: false,
    can_view_audit_all: false,
    can_view_audit_own: false,
    can_manage_system_config: false,
    managed_roles: []
  },
  VERIFICATION_STAFF: {
    can_view_category_z: false,
    can_manage_users: false,
    can_manage_disbursements: false,
    can_review_kyc: true,
    can_edit_clients: false,
    can_assign_clients: false,
    can_flag_clients: false,
    can_raise_client_tickets: false,
    can_record_repayments: false,
    can_contact_clients: false,
    can_log_interactions: false,
    can_view_reports: false,
    can_generate_reports: false,
    can_manage_targets: false,
    can_manage_report_schedules: false,
    can_view_audit_all: false,
    can_view_audit_own: false,
    can_manage_system_config: false,
    managed_roles: []
  },
  CLIENT: {
    can_view_category_z: false,
    can_manage_users: false,
    can_manage_disbursements: false,
    can_review_kyc: false,
    can_edit_clients: false,
    can_assign_clients: false,
    can_flag_clients: false,
    can_raise_client_tickets: false,
    can_record_repayments: false,
    can_contact_clients: false,
    can_log_interactions: false,
    can_view_reports: false,
    can_generate_reports: false,
    can_manage_targets: false,
    can_manage_report_schedules: false,
    can_view_audit_all: false,
    can_view_audit_own: false,
    can_manage_system_config: false,
    managed_roles: []
  }
};
var NAVIGATION_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    section: "Operations",
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.OPS_MANAGER,
      UserRole.AGENT,
      UserRole.VERIFICATION_STAFF
    ]
  },
  {
    key: "clients",
    label: "Clients / Portfolio",
    path: "/clients",
    section: "Operations",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.OPS_MANAGER]
  },
  {
    key: "collections",
    label: "Collections",
    path: "/collections",
    section: "Operations",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.OPS_MANAGER]
  },
  {
    key: "agent_performance",
    label: "Agent Performance",
    path: "/agent-performance",
    section: "Operations",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.OPS_MANAGER]
  },
  {
    key: "verification",
    label: "Verification / KYC",
    path: "/verification",
    section: "Operations",
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.OPS_MANAGER,
      UserRole.VERIFICATION_STAFF
    ]
  },
  {
    key: "borrower_applications",
    label: "Borrower Applications",
    path: "/borrower-applications",
    section: "Operations",
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.OPS_MANAGER,
      UserRole.VERIFICATION_STAFF
    ]
  },
  {
    key: "disbursements",
    label: "Disbursements",
    path: "/disbursements",
    section: "Operations",
    roles: [UserRole.SUPER_ADMIN]
  },
  {
    key: "users",
    label: "Users & Roles",
    path: "/users",
    section: "Administration",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN]
  },
  {
    key: "targets",
    label: "Targets / Assignments",
    path: "/targets",
    section: "Administration",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.OPS_MANAGER]
  },
  {
    key: "reconciliation",
    label: "Reconciliation",
    path: "/reconciliation",
    section: "Administration",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.OPS_MANAGER]
  },
  {
    key: "reports",
    label: "Reports",
    path: "/reports",
    section: "Administration",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.OPS_MANAGER]
  },
  {
    key: "tickets",
    label: "Tickets",
    path: "/tickets",
    section: "Administration",
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.OPS_MANAGER,
      UserRole.AGENT,
      UserRole.VERIFICATION_STAFF
    ]
  },
  {
    key: "pipeline",
    label: "My Pipeline",
    path: "/agent/pipeline",
    section: "Agent",
    roles: [UserRole.AGENT]
  },
  {
    key: "my_clients",
    label: "My Clients",
    path: "/agent/clients",
    section: "Agent",
    roles: [UserRole.AGENT]
  },
  {
    key: "interaction_log",
    label: "Interaction Log",
    path: "/agent/interactions",
    section: "Agent",
    roles: [UserRole.AGENT]
  },
  {
    key: "my_performance",
    label: "My Performance",
    path: "/agent/performance",
    section: "Agent",
    roles: [UserRole.AGENT]
  },
  {
    key: "completed_reviews",
    label: "Completed Reviews",
    path: "/completed-reviews",
    section: "Verification",
    roles: [UserRole.VERIFICATION_STAFF]
  },
  {
    key: "system_config",
    label: "System Configuration",
    path: "/system-config",
    section: "System Control",
    roles: [UserRole.SUPER_ADMIN]
  },
  {
    key: "system_health",
    label: "System Health",
    path: "/system-health",
    section: "System Control",
    roles: [UserRole.SUPER_ADMIN]
  },
  {
    key: "audit_logs",
    label: "Audit Logs",
    path: "/audit-logs",
    section: "System Control",
    roles: [UserRole.SUPER_ADMIN]
  }
];
function getPermissionsForRole(role) {
  return PERMISSIONS[role];
}
function canManageRole(managerRole, targetRole) {
  return PERMISSIONS[managerRole].managed_roles.includes(targetRole);
}
function canReviewKyc(role) {
  return PERMISSIONS[role].can_review_kyc;
}
function canViewCompletedReviews(role) {
  switch (role) {
    case UserRole.SUPER_ADMIN:
    case UserRole.ADMIN:
    case UserRole.OPS_MANAGER:
    case UserRole.VERIFICATION_STAFF:
      return true;
    default:
      return false;
  }
}
function canViewFullAuditLogs(role) {
  return PERMISSIONS[role].can_view_audit_all;
}
function canViewOwnAuditLogs(role) {
  return PERMISSIONS[role].can_view_audit_own;
}
function getNavigationForRole(role) {
  return NAVIGATION_ITEMS.filter(
    (item) => item.key === "completed_reviews" ? canViewCompletedReviews(role) : item.roles.includes(role)
  );
}
function getDefaultPathForRole(role) {
  switch (role) {
    case UserRole.SUPER_ADMIN:
      return "/clients";
    case UserRole.AGENT:
      return "/agent/pipeline";
    case UserRole.VERIFICATION_STAFF:
      return "/verification";
    case UserRole.CLIENT:
      return "/";
    default:
      return "/dashboard";
  }
}
function auditSeverityForAction(actionType) {
  const normalized = actionType.toUpperCase();
  if (normalized.includes("DISBURSE") || normalized.includes("WRITE_OFF") || normalized.includes("ROLE_CHANGE") || normalized.includes("CONFIG")) {
    return AuditSeverity.HIGH_RISK;
  }
  if (normalized.includes("EXPORT") || normalized.includes("ASSIGN") || normalized.includes("LOCK") || normalized.includes("RESET_OTP") || normalized.includes("ESCALATE")) {
    return AuditSeverity.ELEVATED;
  }
  return AuditSeverity.NORMAL;
}

// src/accounts.ts
function deriveUserAccountStatus(user, activityWindowDays = 7) {
  if (!user.is_active || user.deactivated_at) {
    return UserAccountStatus.DEACTIVATED;
  }
  if (user.locked_until_at && new Date(user.locked_until_at) > /* @__PURE__ */ new Date()) {
    return UserAccountStatus.LOCKED;
  }
  if (!user.last_seen_at) {
    return UserAccountStatus.INACTIVE;
  }
  const windowMs = activityWindowDays * 24 * 60 * 60 * 1e3;
  const lastSeenMs = new Date(user.last_seen_at).getTime();
  return Date.now() - lastSeenMs <= windowMs ? UserAccountStatus.ACTIVE : UserAccountStatus.INACTIVE;
}

// src/reports.ts
var PerformanceTargetScopeType = {
  AGENT: "AGENT",
  TEAM: "TEAM",
  ALL_AGENTS: "ALL_AGENTS"
};
var PerformanceTargetTimeframe = {
  WEEKLY: "WEEKLY",
  BI_WEEKLY: "BI_WEEKLY",
  MONTHLY: "MONTHLY",
  CUSTOM: "CUSTOM"
};
var ReportFormat = {
  CSV: "csv",
  PDF: "pdf"
};
var ReportDelivery = {
  DOWNLOAD: "download",
  EMAIL: "email"
};
var ReportRunStatus = {
  QUEUED: "QUEUED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED"
};
var ReportScheduleFrequency = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY"
};
var ReportTemplateKey = {
  DASHBOARD_SNAPSHOT: "DASHBOARD_SNAPSHOT",
  CLIENT_PORTFOLIO_SNAPSHOT: "CLIENT_PORTFOLIO_SNAPSHOT",
  RECOVERY_PERFORMANCE: "RECOVERY_PERFORMANCE",
  COLLECTIONS_PIPELINE_REPORT: "COLLECTIONS_PIPELINE_REPORT",
  TEAM_TARGET_MATRIX: "TEAM_TARGET_MATRIX",
  AGENT_ACTIVITY_REPORT: "AGENT_ACTIVITY_REPORT",
  UNASSIGNED_CLIENTS_REPORT: "UNASSIGNED_CLIENTS_REPORT",
  DEFAULT_RISK_LOG: "DEFAULT_RISK_LOG",
  END_OF_MONTH_AUDIT: "END_OF_MONTH_AUDIT",
  KYC_AML_REGISTRY: "KYC_AML_REGISTRY",
  KYC_PIPELINE_REPORT: "KYC_PIPELINE_REPORT",
  PENALTY_REPORT: "PENALTY_REPORT",
  PAYMENT_BEHAVIOR_REPORT: "PAYMENT_BEHAVIOR_REPORT",
  ESCALATION_FUNNEL_REPORT: "ESCALATION_FUNNEL_REPORT",
  DISBURSEMENT_SUMMARY: "DISBURSEMENT_SUMMARY"
};
var REPORT_TEMPLATE_DEFINITIONS = [
  {
    key: ReportTemplateKey.DASHBOARD_SNAPSHOT,
    name: "Dashboard Snapshot",
    description: "Exports the currently filtered dashboard summary as a structured report.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN", "OPS_MANAGER"],
    default_format: ReportFormat.PDF,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.CLIENT_PORTFOLIO_SNAPSHOT,
    name: "Client Portfolio Snapshot",
    description: "Portfolio balances, lifecycle distribution, and drill-down ready rows.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN", "OPS_MANAGER"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.RECOVERY_PERFORMANCE,
    name: "Recovery Performance",
    description: "Recovery output by team and agent with collections activity metrics.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN", "OPS_MANAGER"],
    default_format: ReportFormat.PDF,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.COLLECTIONS_PIPELINE_REPORT,
    name: "Collections Pipeline Report",
    description: "Pipeline distribution, overdue workload, and collections status by agent.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN", "OPS_MANAGER"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.TEAM_TARGET_MATRIX,
    name: "Team Target Matrix",
    description: "Target definitions and attainment across agents, teams, and rollups.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN"],
    default_format: ReportFormat.PDF,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: false,
    can_include_category_z: false
  },
  {
    key: ReportTemplateKey.AGENT_ACTIVITY_REPORT,
    name: "Agent Activity Report",
    description: "Interaction volume, last seen, and pipeline movement across managed agents.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: false,
    can_include_category_z: false
  },
  {
    key: ReportTemplateKey.UNASSIGNED_CLIENTS_REPORT,
    name: "Unassigned Clients Report",
    description: "Overdue clients awaiting assignment, including queue aging and exposure.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: false
  },
  {
    key: ReportTemplateKey.DEFAULT_RISK_LOG,
    name: "Default Risk Log",
    description: "Overdue exposure across categories with recovery and promise-to-pay signals.",
    allowed_roles: ["SUPER_ADMIN"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.END_OF_MONTH_AUDIT,
    name: "End of Month Audit",
    description: "Finance and audit summary for the reporting period.",
    allowed_roles: ["SUPER_ADMIN"],
    default_format: ReportFormat.PDF,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.EMAIL,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.KYC_AML_REGISTRY,
    name: "KYC / AML Registry",
    description: "Verification pipeline registry with approvals, rejects, and aging.",
    allowed_roles: ["SUPER_ADMIN"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: false,
    can_include_category_z: false
  },
  {
    key: ReportTemplateKey.KYC_PIPELINE_REPORT,
    name: "KYC Pipeline Report",
    description: "Verification queue status, reviewer activity, and pending aging.",
    allowed_roles: ["SUPER_ADMIN", "ADMIN", "OPS_MANAGER"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: false,
    can_include_category_z: false
  },
  {
    key: ReportTemplateKey.PENALTY_REPORT,
    name: "Penalty Report",
    description: "Penalty application, waivers, and cap exposure across the portfolio.",
    allowed_roles: ["SUPER_ADMIN"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.PAYMENT_BEHAVIOR_REPORT,
    name: "Payment Behavior Report",
    description: "On-time rates, partial payments, repeat default signals, and channel mix.",
    allowed_roles: ["SUPER_ADMIN", "OPS_MANAGER"],
    default_format: ReportFormat.CSV,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.ESCALATION_FUNNEL_REPORT,
    name: "Escalation Funnel Report",
    description: "Overdue category migration, resolution drop-off, and escalation timing.",
    allowed_roles: ["SUPER_ADMIN", "OPS_MANAGER"],
    default_format: ReportFormat.PDF,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: true
  },
  {
    key: ReportTemplateKey.DISBURSEMENT_SUMMARY,
    name: "Disbursement Summary",
    description: "Disbursement approvals, failures, and throughput by period.",
    allowed_roles: ["SUPER_ADMIN"],
    default_format: ReportFormat.PDF,
    supported_formats: [ReportFormat.CSV, ReportFormat.PDF],
    default_delivery: ReportDelivery.DOWNLOAD,
    supports_email: true,
    includes_financials: true,
    can_include_category_z: false
  }
];
function getReportTemplateDefinition(key) {
  return REPORT_TEMPLATE_DEFINITIONS.find((template) => template.key === key);
}
function getReportTemplateDefinitionsForRole(role) {
  return REPORT_TEMPLATE_DEFINITIONS.filter((template) => template.allowed_roles.includes(role));
}
function normalizeRecipientEmails(emails) {
  if (!emails?.length) {
    return [];
  }
  const normalized = emails.map((entry) => entry.trim().toLowerCase()).filter((entry) => entry.length > 0);
  return [...new Set(normalized)];
}
function atUtcTime(date, hour, minute) {
  const next = new Date(date);
  next.setUTCHours(hour, minute, 0, 0);
  return next;
}
function daysInUtcMonth(year, monthIndex) {
  return new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
}
function computeNextReportRun(options) {
  const reference = options.from ? new Date(options.from) : /* @__PURE__ */ new Date();
  const seed = new Date(reference.getTime() + 6e4);
  if (options.frequency === ReportScheduleFrequency.DAILY) {
    const candidate2 = atUtcTime(seed, options.run_hour_utc, options.run_minute_utc);
    if (candidate2 <= reference) {
      candidate2.setUTCDate(candidate2.getUTCDate() + 1);
    }
    return candidate2.toISOString().replace(/\.\d{3}Z$/, "Z");
  }
  if (options.frequency === ReportScheduleFrequency.WEEKLY) {
    const targetDay = options.run_day_of_week ?? 1;
    const candidate2 = atUtcTime(seed, options.run_hour_utc, options.run_minute_utc);
    const dayDelta = (targetDay - candidate2.getUTCDay() + 7) % 7;
    candidate2.setUTCDate(candidate2.getUTCDate() + dayDelta);
    if (candidate2 <= reference) {
      candidate2.setUTCDate(candidate2.getUTCDate() + 7);
    }
    return candidate2.toISOString().replace(/\.\d{3}Z$/, "Z");
  }
  const dayOfMonth = Math.max(1, Math.min(options.run_day_of_month ?? 1, 28));
  const candidate = atUtcTime(seed, options.run_hour_utc, options.run_minute_utc);
  const currentMaxDay = daysInUtcMonth(candidate.getUTCFullYear(), candidate.getUTCMonth());
  candidate.setUTCDate(Math.min(dayOfMonth, currentMaxDay));
  if (candidate <= reference) {
    candidate.setUTCMonth(candidate.getUTCMonth() + 1, 1);
    const maxDay = daysInUtcMonth(candidate.getUTCFullYear(), candidate.getUTCMonth());
    candidate.setUTCDate(Math.min(dayOfMonth, maxDay));
  }
  return candidate.toISOString().replace(/\.\d{3}Z$/, "Z");
}
function buildReportFilename(templateKey, publicId, format) {
  return `${templateKey.toLowerCase()}_${publicId.toLowerCase()}.${format}`;
}

// src/money.ts
var BASE_CURRENCY = "USD";
function sortCurrencyAmounts(amounts) {
  return [...amounts].sort((left, right) => {
    if (left.currency === right.currency) {
      return 0;
    }
    if (left.currency === BASE_CURRENCY) {
      return -1;
    }
    if (right.currency === BASE_CURRENCY) {
      return 1;
    }
    return left.currency.localeCompare(right.currency);
  });
}
function rollupCurrencyAmounts(amounts) {
  const totals = amounts.reduce((accumulator, entry) => {
    accumulator.set(entry.currency, (accumulator.get(entry.currency) ?? 0) + entry.amount);
    return accumulator;
  }, /* @__PURE__ */ new Map());
  return sortCurrencyAmounts(
    [...totals.entries()].map(([currency, amount]) => ({
      currency,
      amount
    }))
  );
}

// src/portal-notifications.ts
var PORTAL_NOTIFICATION_EVENTS = [
  "PAYMENT_RECEIVED",
  "PAYMENT_DUE_SOON",
  "PAYMENT_OVERDUE",
  "PTP_DAY_REMINDER",
  "MANUAL_PAYMENT_VERIFIED",
  "MANUAL_PAYMENT_REJECTED",
  "LOAN_DISBURSED",
  "LOAN_CLOSED",
  "MICRO_LOAN_TIER_PROMOTED",
  "MICRO_LOAN_TIER_DEMOTED",
  "MICRO_LOAN_REJECTION",
  "KYC_STATUS_UPDATE",
  "KYC_ACTION_REQUIRED",
  "TICKET_RESPONSE"
];
function money(currency, amountMinor) {
  if (typeof amountMinor !== "number") {
    return currency;
  }
  return new Intl.NumberFormat("en-ZW", {
    style: "currency",
    currency,
    currencyDisplay: "code",
    minimumFractionDigits: 2
  }).format(amountMinor / 100);
}
function text(payload, key, fallback = "") {
  const value = payload[key];
  return typeof value === "string" ? value : fallback;
}
function integer(payload, key) {
  const value = payload[key];
  return typeof value === "number" ? value : void 0;
}
function englishTemplate(eventType, payload) {
  const currency = text(payload, "currency", BASE_CURRENCY);
  const balance = money(currency, integer(payload, "outstanding_balance"));
  const amount = money(currency, integer(payload, "amount"));
  const loanId = text(payload, "loan_id");
  const tierName = text(payload, "tier_name");
  const ceiling = money(currency, integer(payload, "ceiling"));
  const newCeiling = money(currency, integer(payload, "new_ceiling"));
  const rejectionReason = text(payload, "rejection_reason", "Please review the payment details and submit again.");
  switch (eventType) {
    case "PAYMENT_RECEIVED":
      return {
        title: "Payment received",
        body: `${amount} has been received for ${loanId}. Outstanding balance: ${balance}.`,
        deep_link: "/payments",
        sms_body: `LoanCore: Payment received for ${loanId}. Amount ${amount}. Balance ${balance}.`
      };
    case "PAYMENT_DUE_SOON":
      return {
        title: "Payment due soon",
        body: `${loanId} is due soon. Amount due: ${amount}.`,
        deep_link: "/payments",
        sms_body: `LoanCore reminder: ${loanId} is due soon. Amount due ${amount}.`
      };
    case "PAYMENT_OVERDUE":
      return {
        title: "Payment overdue",
        body: `${loanId} is overdue. Outstanding balance: ${balance}.`,
        deep_link: "/payments",
        sms_body: `LoanCore alert: ${loanId} is overdue. Outstanding balance ${balance}.`
      };
    case "PTP_DAY_REMINDER":
      return {
        title: "Promise to pay reminder",
        body: `This is your reminder to pay ${loanId} today. Amount due: ${amount}.`,
        deep_link: "/payments",
        sms_body: `LoanCore reminder: Please pay ${loanId} today. Amount due ${amount}.`
      };
    case "MANUAL_PAYMENT_VERIFIED":
      return {
        title: "Manual payment verified",
        body: `Your manual payment for ${loanId} has been verified.`,
        deep_link: "/payments"
      };
    case "MANUAL_PAYMENT_REJECTED":
      return {
        title: "Manual payment rejected",
        body: rejectionReason,
        deep_link: "/payments"
      };
    case "LOAN_DISBURSED":
      return {
        title: "Loan disbursed",
        body: `Funds for ${loanId} have been released. Amount: ${amount}.`,
        deep_link: "/",
        sms_body: `LoanCore: Your loan ${loanId} has been disbursed. Amount ${amount}.`
      };
    case "LOAN_CLOSED":
      return {
        title: "Loan closed",
        body: `${loanId} is now fully settled.`,
        deep_link: "/",
        sms_body: `LoanCore: Your loan ${loanId} is fully settled.`
      };
    case "MICRO_LOAN_TIER_PROMOTED":
      return {
        title: "Tier upgraded",
        body: `You are now in ${tierName}. You can borrow up to ${ceiling}.`,
        deep_link: "/",
        sms_body: `LoanCore: You are now in ${tierName}. Borrow up to ${ceiling}.`
      };
    case "MICRO_LOAN_TIER_DEMOTED":
      return {
        title: "Tier updated",
        body: `Your quick-loan limit is now ${newCeiling}. Repay on time to rebuild your tier.`,
        deep_link: "/",
        sms_body: `LoanCore: Your quick-loan limit is now ${newCeiling}. Repay on time to rebuild your tier.`
      };
    case "MICRO_LOAN_REJECTION":
      return {
        title: "Quick loan unavailable",
        body: rejectionReason,
        deep_link: "/quick-loan",
        sms_body: rejectionReason
      };
    case "KYC_STATUS_UPDATE":
      return {
        title: "KYC status updated",
        body: `Your verification status is now ${text(payload, "decision", "updated")}.`,
        deep_link: "/profile"
      };
    case "KYC_ACTION_REQUIRED":
      return {
        title: "More KYC information needed",
        body: text(
          payload,
          "message",
          "We need more information or clearer documents to continue your KYC review."
        ),
        deep_link: "/onboarding",
        sms_body: text(
          payload,
          "message",
          "LoanCore: More KYC information is needed. Open onboarding to respond."
        )
      };
    case "TICKET_RESPONSE":
      return {
        title: "Support replied",
        body: `There is a new update on ticket ${text(payload, "ticket_id")}.`,
        deep_link: "/support"
      };
  }
}
function shonaTemplate(eventType, payload) {
  const currency = text(payload, "currency", BASE_CURRENCY);
  const balance = money(currency, integer(payload, "outstanding_balance"));
  const amount = money(currency, integer(payload, "amount"));
  const loanId = text(payload, "loan_id");
  const tierName = text(payload, "tier_name");
  const ceiling = money(currency, integer(payload, "ceiling"));
  const newCeiling = money(currency, integer(payload, "new_ceiling"));
  const rejectionReason = text(
    payload,
    "rejection_reason",
    "Tarisa mashoko ekubhadhara wozoedza zvakare."
  );
  switch (eventType) {
    case "PAYMENT_RECEIVED":
      return {
        title: "Mari yagamuchirwa",
        body: `${amount} yagamuchirwa pa${loanId}. Mari yasara: ${balance}.`,
        deep_link: "/payments",
        sms_body: `LoanCore: Mari yako yagamuchirwa pa${loanId}. Mari ${amount}. Yasara ${balance}.`
      };
    case "PAYMENT_DUE_SOON":
      return {
        title: "Nguva yekubhadhara yava pedyo",
        body: `${loanId} yava pedyo nenguva yekubhadhara. Mari inodiwa: ${amount}.`,
        deep_link: "/payments",
        sms_body: `LoanCore: Rangarirai kubhadhara ${loanId}. Mari inodiwa ${amount}.`
      };
    case "PAYMENT_OVERDUE":
      return {
        title: "Kubhadhara kwapfuura nguva",
        body: `${loanId} yapfuura nguva. Mari yasara: ${balance}.`,
        deep_link: "/payments",
        sms_body: `LoanCore: ${loanId} yapfuura nguva. Mari yasara ${balance}.`
      };
    case "PTP_DAY_REMINDER":
      return {
        title: "Rangaridzo yechivimbiso chekubhadhara",
        body: `Rangarirai kubhadhara ${loanId} nhasi. Mari inodiwa: ${amount}.`,
        deep_link: "/payments",
        sms_body: `LoanCore: Rangarirai kubhadhara ${loanId} nhasi. Mari inodiwa ${amount}.`
      };
    case "MANUAL_PAYMENT_VERIFIED":
      return {
        title: "Kubhadhara kwasimbiswa",
        body: `Kubhadhara kwenyu kwe${loanId} kwasimbiswa.`,
        deep_link: "/payments"
      };
    case "MANUAL_PAYMENT_REJECTED":
      return {
        title: "Kubhadhara kwarambwa",
        body: rejectionReason,
        deep_link: "/payments"
      };
    case "LOAN_DISBURSED":
      return {
        title: "Chikwereti chabudiswa",
        body: `Mari ye${loanId} yaburitswa. Huwandu: ${amount}.`,
        deep_link: "/",
        sms_body: `LoanCore: Chikwereti chenyu ${loanId} chaburitswa. Mari ${amount}.`
      };
    case "LOAN_CLOSED":
      return {
        title: "Chikwereti chapera",
        body: `${loanId} chapera zvizere.`,
        deep_link: "/",
        sms_body: `LoanCore: Chikwereti chenyu ${loanId} chapera zvizere.`
      };
    case "MICRO_LOAN_TIER_PROMOTED":
      return {
        title: "Tier yakwezwa",
        body: `Mava mu${tierName}. Mungakwereta kusvika ${ceiling}.`,
        deep_link: "/",
        sms_body: `LoanCore: Mava mu${tierName}. Mungakwereta kusvika ${ceiling}.`
      };
    case "MICRO_LOAN_TIER_DEMOTED":
      return {
        title: "Tier yachinja",
        body: `Muganhu wenyu wequick-loan wava ${newCeiling}. Bhadharai nenguva kuti mukwidze tier zvakare.`,
        deep_link: "/",
        sms_body: `LoanCore: Muganhu wenyu wequick-loan wava ${newCeiling}. Bhadharai nenguva kuti mukwidze tier zvakare.`
      };
    case "MICRO_LOAN_REJECTION":
      return {
        title: "Quick loan harisipo",
        body: rejectionReason,
        deep_link: "/quick-loan",
        sms_body: rejectionReason
      };
    case "KYC_STATUS_UPDATE":
      return {
        title: "Mamiro eKYC achinja",
        body: `Mamiro enyu eKYC ave ${text(payload, "decision", "achinja")}.`,
        deep_link: "/profile"
      };
    case "KYC_ACTION_REQUIRED":
      return {
        title: "Rumwe ruzivo rweKYC runodiwa",
        body: text(
          payload,
          "message",
          "Tinoda rumwe ruzivo kana magwaro akajeka kuti tienderere mberi nekuongorora KYC yenyu."
        ),
        deep_link: "/onboarding",
        sms_body: text(
          payload,
          "message",
          "LoanCore: Pane rumwe ruzivo rweKYC runodiwa. Vhurai onboarding kuti mupindure."
        )
      };
    case "TICKET_RESPONSE":
      return {
        title: "Support yapindura",
        body: `Pane mhinduro itsva patikiti ${text(payload, "ticket_id")}.`,
        deep_link: "/support"
      };
  }
}
function isPortalNotificationEvent(eventType) {
  return PORTAL_NOTIFICATION_EVENTS.includes(eventType);
}
function renderPortalNotification(eventType, payload, language = "en") {
  if (language === "sn") {
    return shonaTemplate(eventType, payload);
  }
  return englishTemplate(eventType, payload);
}

// src/micro-loans.ts
var MICRO_LOAN_TIERS = [
  MicroLoanTier.T1,
  MicroLoanTier.T2,
  MicroLoanTier.T3,
  MicroLoanTier.T4,
  MicroLoanTier.T5
];
var MICRO_LOAN_TIER_NAMES = {
  T1: "Starter",
  T2: "Basic",
  T3: "Standard",
  T4: "Enhanced",
  T5: "Premium"
};
var MICRO_LOAN_OVERRIDE_REASONS = [
  TierChangeReason.ADMIN_REMEDIATION,
  TierChangeReason.PROMOTIONAL,
  TierChangeReason.CORRECTING_SYSTEM_ERROR,
  TierChangeReason.OTHER
];
var MICRO_LOAN_TIER_CHANGE_DIRECTIONS = [
  TierChangeDirection.INITIAL,
  TierChangeDirection.PROMOTION,
  TierChangeDirection.DEMOTION,
  TierChangeDirection.MANUAL_OVERRIDE,
  TierChangeDirection.FREEZE,
  TierChangeDirection.UNFREEZE
];
var MICRO_LOAN_FREEZE_REASONS = [
  MicroLoanFreezeReason.WRITE_OFF,
  MicroLoanFreezeReason.MANUAL_FREEZE
];
function getNextMicroLoanTier(tier) {
  const index = MICRO_LOAN_TIERS.indexOf(tier ?? "");
  if (index < 0 || index === MICRO_LOAN_TIERS.length - 1) {
    return null;
  }
  return MICRO_LOAN_TIERS[index + 1];
}
function getPreviousMicroLoanTier(tier) {
  const index = MICRO_LOAN_TIERS.indexOf(tier ?? "");
  if (index <= 0) {
    return null;
  }
  return MICRO_LOAN_TIERS[index - 1];
}
function getMicroLoanTierName(tier) {
  if (!tier) return null;
  return MICRO_LOAN_TIER_NAMES[tier] ?? null;
}

// src/triggers.ts
var TRIGGER_CRON_SCHEDULES = {
  [TriggerKey.CRON_CATEGORY_MIGRATION]: "15 0 * * *",
  [TriggerKey.CRON_PENALTY_CALCULATION]: "30 0 * * *",
  [TriggerKey.CRON_PTP_TO_BP_CONVERSION]: "5 * * * *",
  [TriggerKey.CRON_UNPROCESSED_TIME_ALERT]: "0 */4 * * *",
  [TriggerKey.CRON_TARGET_SHORTFALL_WARNING]: "0 6 * * *",
  [TriggerKey.CRON_PRE_DUE_REMINDER]: "0 7 * * *",
  [TriggerKey.CRON_PTP_DAY_REMINDER]: "0 7 * * *",
  [TriggerKey.CRON_PAYMENT_RECONCILIATION]: "0 */4 * * *",
  [TriggerKey.CRON_SCHEDULED_REPORT_GENERATION]: "0 3 * * *",
  [TriggerKey.CRON_MICRO_TIER_SWEEP]: "0 2 * * *",
  [TriggerKey.CRON_MICRO_FREEZE_SYNC]: "0 1 * * *",
  [TriggerKey.CRON_TICKET_SLA_MONITOR]: "*/30 * * * *",
  [TriggerKey.CRON_BACKUP]: "0 4 * * *"
};
function getTriggerDisplayName(triggerKey) {
  return triggerKey.replace(/^CRON_/, "").replace(/^EVENT_/, "").replace(/^THRESHOLD_/, "").replace(/^NOTIFY_/, "").replace(/^ALERT_/, "").split("_").map((word) => word.charAt(0) + word.slice(1).toLowerCase()).join(" ");
}
var NOTIFICATION_KEY_EVENT_TYPES = {
  [NotificationKey.NOTIFY_LOAN_DISBURSEMENT]: "LOAN_DISBURSED",
  [NotificationKey.NOTIFY_PAYMENT_RECEIVED]: "PAYMENT_RECEIVED",
  [NotificationKey.NOTIFY_PRE_DUE_REMINDER]: "PAYMENT_DUE_SOON",
  [NotificationKey.NOTIFY_OVERDUE_NOTICE]: "PAYMENT_OVERDUE",
  [NotificationKey.NOTIFY_CATEGORY_ESCALATION]: "PAYMENT_OVERDUE",
  [NotificationKey.NOTIFY_PTP_REMINDER]: "PTP_DAY_REMINDER",
  [NotificationKey.NOTIFY_LOAN_CLOSURE]: "LOAN_CLOSED",
  [NotificationKey.NOTIFY_MANUAL_PAYMENT_VERIFIED]: "MANUAL_PAYMENT_VERIFIED",
  [NotificationKey.NOTIFY_MANUAL_PAYMENT_REJECTED]: "MANUAL_PAYMENT_REJECTED",
  [NotificationKey.NOTIFY_KYC_STATUS_UPDATE]: "KYC_STATUS_UPDATE",
  [NotificationKey.NOTIFY_TICKET_RESPONSE]: "TICKET_RESPONSE",
  [NotificationKey.NOTIFY_MICRO_TIER_PROMOTION]: "MICRO_LOAN_TIER_PROMOTED",
  [NotificationKey.NOTIFY_MICRO_TIER_DEMOTION]: "MICRO_LOAN_TIER_DEMOTED",
  [NotificationKey.NOTIFY_MICRO_LOAN_REJECTION]: "MICRO_LOAN_REJECTION",
  [NotificationKey.NOTIFY_NEW_CLIENT_ASSIGNMENT]: "NEW_CLIENT_ASSIGNMENT",
  [NotificationKey.NOTIFY_PTP_EXPIRY]: "PTP_EXPIRED",
  [NotificationKey.NOTIFY_UNPROCESSED_TIME_ALERT]: "UNPROCESSED_TIME_ALERT",
  [NotificationKey.NOTIFY_TARGET_SHORTFALL_WARNING]: "TARGET_SHORTFALL_WARNING",
  [NotificationKey.NOTIFY_CATEGORY_Z_ENTRY]: "CATEGORY_Z_ENTRY",
  [NotificationKey.NOTIFY_KYC_COMPLETION]: "KYC_COMPLETED",
  [NotificationKey.NOTIFY_TICKET_ESCALATION]: "TICKET_ESCALATION"
};
function notificationEventType(notificationKey, fallback) {
  if (notificationKey && notificationKey in NOTIFICATION_KEY_EVENT_TYPES) {
    return NOTIFICATION_KEY_EVENT_TYPES[notificationKey];
  }
  return fallback ?? "SYSTEM_NOTIFICATION";
}
var ALERT_KEY_EVENT_TYPES = {
  [AlertKey.ALERT_BACKUP_FAILURE]: "BACKUP_FAILURE",
  [AlertKey.ALERT_CRITICAL_SERVICE_DOWN]: "CRITICAL_SERVICE_DOWN",
  [AlertKey.ALERT_MIGRATION_SPIKE]: "MIGRATION_SPIKE",
  [AlertKey.ALERT_DISBURSEMENT_EXHAUSTED]: "DISBURSEMENT_EXHAUSTED"
};
function alertEventType(alertKey, fallback) {
  if (alertKey && alertKey in ALERT_KEY_EVENT_TYPES) {
    return ALERT_KEY_EVENT_TYPES[alertKey];
  }
  return fallback ?? "SYSTEM_ALERT";
}
export {
  ALERT_KEY_EVENT_TYPES,
  AlertKey,
  AuditSeverity,
  BASE_CURRENCY,
  BorrowerApplicationStatus,
  CLIENT_NAME_MAX_LEN,
  ClientFacingOverdueLabel,
  DisbursementStatus,
  ID_PREFIX,
  InteractionOutcome,
  InteractionType,
  KycDocumentType,
  KycStatus,
  LOAN_AMOUNT_MAX,
  LOAN_AMOUNT_MIN,
  LoanLifecycleStage,
  LoanType,
  MAX_KYC_UPLOAD_SIZE_BYTES,
  MICRO_LOAN_AMOUNT_MIN,
  MICRO_LOAN_FREEZE_REASONS,
  MICRO_LOAN_OVERRIDE_REASONS,
  MICRO_LOAN_TIERS,
  MICRO_LOAN_TIER_CHANGE_DIRECTIONS,
  MICRO_LOAN_TIER_NAMES,
  MicroLoanFreezeReason,
  MicroLoanTier,
  NATIONAL_ID_MAX_LEN,
  NAVIGATION_ITEMS,
  NOTES_MAX_LEN,
  NOTIFICATION_KEY_EVENT_TYPES,
  NotificationKey,
  OPTIONAL_KYC_DOCUMENT_TYPES,
  OverdueCategory,
  PHONE_REGEX,
  PORTAL_NOTIFICATION_EVENTS,
  PenaltyCompoundingMethod,
  PerformanceTargetScopeType,
  PerformanceTargetTimeframe,
  PipelineStatus,
  PortalPaymentMethod,
  PortalPaymentStatus,
  REPORT_TEMPLATE_DEFINITIONS,
  REQUIRED_KYC_DOCUMENT_TYPES,
  ReportDelivery,
  ReportFormat,
  ReportRunStatus,
  ReportScheduleFrequency,
  ReportTemplateKey,
  SystemAlertStatus,
  TRIGGER_CRON_SCHEDULES,
  ThresholdKey,
  TicketPriority,
  TicketStatus,
  TicketType,
  TierChangeDirection,
  TierChangeReason,
  TriggerExecutionModel,
  TriggerExecutionStatus,
  TriggerFailureDispositionStatus,
  TriggerKey,
  UserAccountStatus,
  UserRole,
  addDays,
  alertEventType,
  arrayBufferToHex,
  auditSeverityForAction,
  buildMeta,
  buildReportFilename,
  businessRuleViolation,
  canManageRole,
  canReviewKyc,
  canViewCompletedReviews,
  canViewFullAuditLogs,
  canViewOwnAuditLogs,
  computeNextReportRun,
  conflict,
  daysBetween,
  deriveUserAccountStatus,
  errorResponse,
  forbidden,
  formatPublicId,
  generateOtp,
  generateUUID,
  getDefaultPathForRole,
  getMicroLoanTierName,
  getNavigationForRole,
  getNextMicroLoanTier,
  getPermissionsForRole,
  getPreviousMicroLoanTier,
  getReportTemplateDefinition,
  getReportTemplateDefinitionsForRole,
  getTriggerDisplayName,
  hmacHash,
  internalError,
  isPortalNotificationEvent,
  isValidE164,
  isValidPhone,
  normalizeRecipientEmails,
  notFound,
  notificationEventType,
  nowISO,
  parsePagination,
  rateLimited,
  renderPortalNotification,
  rollupCurrencyAmounts,
  sortCurrencyAmounts,
  successResponse,
  unauthenticated,
  validationError
};
